import { urlIncorporare } from '../utils/video-embed';

interface Props {
    video: string | null | undefined;
    start?: number | null;
    end?: number | null;
    titlu: string;
}

/**
 * Filmul unei lectii, pe pagina publica. Fara autoplay (pagina se deschide pe date mobile) si fara
 * logica de „vizionat" a playerului de lectie. `aspect-video` rezerva locul inainte sa vina iframe-ul,
 * deci textul de dedesubt nu sare; `loading="lazy"` il amana pana aproape de ecran.
 */
export function VideoIncorporat({ video, start, end, titlu }: Props) {
    const src = urlIncorporare(video, start, end);
    if (!src) return null;
    return (
        <div className="aspect-video w-full overflow-hidden rounded-lg bg-dark" data-colab-video>
            <iframe
                src={src}
                title={titlu}
                loading="lazy"
                className="size-full border-0"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
            />
        </div>
    );
}
